import { render, staticRenderFns } from "./truncate-text-tooltip.vue?vue&type=template&id=155e4ffd"
import script from "./truncate-text-tooltip.vue?vue&type=script&lang=js"
export * from "./truncate-text-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports